import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "summary w-100 text-start p-1 mt-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex flex-row mt-3" }
const _hoisted_4 = { class: "flex-grow-1 text-start" }
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-row"
}
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = { class: "d-flex flex-row mt-2 mb-4" }
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = { class: "h5 bold" }
const _hoisted_11 = { class: "mb-3 required-input-wrapper" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "dropdown" }
const _hoisted_15 = {
  class: "btn btn-secondary dropdown-toggle btn-dropdelivery",
  type: "button",
  id: "dropdownDelivery",
  "data-bs-toggle": "dropdown"
}
const _hoisted_16 = { class: "dropdown-menu dropdown-menu-end p-2" }
const _hoisted_17 = ["value", "onClick"]
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "country fw-bold" }
const _hoisted_20 = { class: "city text-end fw-bold" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = {
  key: 0,
  class: "delivery-selected-wrap"
}
const _hoisted_23 = { class: "delivery-selected" }
const _hoisted_24 = { class: "d-flex justify-content-between" }
const _hoisted_25 = { class: "country fw-bold" }
const _hoisted_26 = { class: "city text-end fw-bold" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cartStore.cart.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[21] || (_cache[21] = _createElementVNode("h5", { class: "bold" }, "Summary", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, " Total sum (" + _toDisplayString(_ctx.cartStore.cart.length > 0 ? _ctx.cartStore.cart.length : 0) + " " + _toDisplayString(_ctx.cartStore.cart.length === 1 ? "product" : "products") + ") ", 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.cartStore.cart.length > 0
              ? _ctx.formatCurrency(
                  _ctx.cartStore.totalPrice,
                  _ctx.cartStore.cart[0].product.currency
                )
              : 0), 1)
          ]),
          (_ctx.cartStore.cart.length > 0 && _ctx.cartStore.totalDiscount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-grow-1 text-start" }, "Total discount", -1)),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.cartStore.cart.length > 0
              ? "-" +
                _ctx.formatCurrency(
                  _ctx.cartStore.totalDiscount,
                  _ctx.cartStore.cart[0].product.currency
                )
              : 0), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-grow-1 text-start" }, [
              _createElementVNode("label", { class: "h5 bold" }, "Total to pay")
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.cartStore.cart.length > 0
              ? _ctx.formatCurrency(
                  _ctx.cartStore.totalOrderPrice,
                  _ctx.cartStore.cart[0].product.currency
                )
              : 0), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "required-asterisk" }, "*", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderReference) = $event)),
              placeholder: "Order reference..."
            }, null, 512), [
              [_vModelText, _ctx.orderReference]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderMessage) = $event)),
              placeholder: "Optional message to us...",
              rows: "3"
            }, null, 512), [
              [_vModelText, _ctx.orderMessage]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "h5 bold" }, [
              _createElementVNode("span", { class: "text-danger" }, "*"),
              _createTextVNode("Delivery Address")
            ], -1)),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.selectedDeliveryAddress
                ? `${_ctx.selectedDeliveryAddress.addressCountryRegionId}, ${_ctx.selectedDeliveryAddress.addressCity}`
                : "Select delivery address..."), 1),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryAddresses, (value) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: value.addressZipCode,
                    value: value,
                    class: "row delivery-item",
                    onClick: ($event: any) => (_ctx.selectDeliveryAddress(value))
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, "Country: " + _toDisplayString(value.addressCountryRegionId || ""), 1),
                      _createElementVNode("span", _hoisted_20, "City: " + _toDisplayString(value.addressCity || ""), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[8] || (_cache[8] = _createElementVNode("b", null, "Address:", -1)),
                      _cache[9] || (_cache[9] = _createTextVNode()),
                      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(value.addressStreet || "") + " ", 1),
                      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(value.addressZipCode || "") + " ", 1),
                      _cache[12] || (_cache[12] = _createElementVNode("b", null, "Description:", -1)),
                      _createTextVNode(" " + _toDisplayString(value.addressDescription || ""), 1)
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "delivery-divider" }, null, -1))
                  ], 8, _hoisted_17))
                }), 128)),
                _createElementVNode("div", {
                  class: "row delivery-item py-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDeliveryAddress = undefined))
                }, _cache[14] || (_cache[14] = [
                  _createElementVNode("div", { class: "col-12" }, "Leave empty", -1)
                ]))
              ])
            ]),
            (_ctx.selectedDeliveryAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, "Country: " + _toDisplayString(_ctx.selectedDeliveryAddress.addressCountryRegionId || ""), 1),
                      _createElementVNode("span", _hoisted_26, "City: " + _toDisplayString(_ctx.selectedDeliveryAddress.addressCity || ""), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[15] || (_cache[15] = _createElementVNode("b", null, "Address:", -1)),
                      _cache[16] || (_cache[16] = _createTextVNode()),
                      _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedDeliveryAddress.addressStreet || "") + " ", 1),
                      _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedDeliveryAddress.addressZipCode || "") + " ", 1),
                      _cache[19] || (_cache[19] = _createElementVNode("b", null, "Description:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.selectedDeliveryAddress.addressDescription || ""), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              disabled: 
            _ctx.cartStore.cart.length === 0 ||
            _ctx.isLoading ||
            _ctx.cartStore.totalOrderPrice === 0
          ,
              class: "btn btn-primary w-100",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendOrder()))
            }, _toDisplayString(_ctx.isLoading ? "Placing order..." : "Place order"), 9, _hoisted_29),
            _createVNode(_component_Loading, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderSent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _cache[22] || (_cache[22] = _createElementVNode("h5", { class: "bold" }, "Order sent", -1)),
          _cache[23] || (_cache[23] = _createTextVNode(" Your order is sent to us.")),
          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
          _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
          _cache[26] || (_cache[26] = _createTextVNode(" An order confirmation should be sent to your mail within five working days. ")),
          _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
          _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
          _cache[29] || (_cache[29] = _createTextVNode(" Thank you for your order. ")),
          _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
          _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/')))
          }, " Back to home "),
          _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
          _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
          _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
          _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
          _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
          _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
          _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
          _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
          _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
          _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}